'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSFetchError = void 0;
class CMSFetchError extends Error {
    constructor(payload) {
        var _a, _b;
        const { tenantConfig, module, error, moduleCategory } = payload;
        super();
        this.error_details = {};
        const category = moduleCategory ? `${moduleCategory} - ` : '';
        const errorSegments = [
            `[${tenantConfig.countryCode}]`,
            `[${category}${module}]`
        ];
        this.name = 'CMSFetchError';
        this.tenantConfig = tenantConfig;
        this.module = module;
        this.message = `Failed to fetch ${errorSegments.join('')}`;
        this.error_details = {
            name: error.name,
            message: error.message,
            response: {
                status: (_a = error.response) === null || _a === void 0 ? void 0 : _a.status,
                body: (_b = error.response) === null || _b === void 0 ? void 0 : _b.data
            }
        };
    }
}
exports.CMSFetchError = CMSFetchError;
//# sourceMappingURL=fetch.error.js.map